import React from 'react';
import { Row, Col } from 'react-bootstrap';
import Skeleton from '../../common/skeleton';

const ReportsTableSkeleton = () => {
  return (
    <div>
      <Row className="my-3">
        <Col>
          <Skeleton height={30} width={250} count={1} />
        </Col>
        <Col className="text-right">
          <Skeleton
            height={30}
            width={180}
            count={1}
            containerClassName={'mr-2s'}
          />
        </Col>
      </Row>
      <div>
        <Skeleton height={45} width={'100%'} count={7} className={'mb-2'} />
      </div>
      <Row className="my-3">
        <Col>
          <Skeleton height={30} width={250} count={1} />
        </Col>
        <Col className="text-right">
          <Skeleton
            height={30}
            width={180}
            count={1}
            containerClassName={'mr-2'}
          />
        </Col>
      </Row>
    </div>
  );
};

export default ReportsTableSkeleton;
